<template>
    <div v-observe-visibility="visibilityChanged">

        <v-layout id="table-container" row>
            <v-flex xs12 pr-4 pt-4 pl-4>
                <v-card>
                    <v-card-title>
                        Unconfirmed Offer Positions
                        <v-spacer></v-spacer>
                        <v-text-field
                                v-model="search"
                                append-icon="search"
                                label="Search"
                                single-line
                                hide-details
                                clearable
                        ></v-text-field>
                    </v-card-title>

                    <v-data-table
                            v-model="selectedOfferPositions"
                            :headers="headers"
                            :items="getItems"
                            :pagination.sync="pagination"
                            :total-items=total
                            class="elevation-0 offer-table"
                            :loading="loading"
                            :rows-per-page-items="rowsPageItems"
                            select-all
                    >

                        <template slot="headerCell" slot-scope="props">
                            <v-tooltip bottom>
                                        <span slot="activator">
                                          {{ props.header.text }}
                                        </span>
                                <span>
                                          {{ props.header.text }}
                                        </span>
                            </v-tooltip>
                        </template>
                        <template slot="items" slot-scope="props">
                            <tr>
                                <td>
                                    <v-checkbox
                                            v-model="props.selected"
                                            color="secondary"
                                            hide-details
                                    ></v-checkbox>
                                </td>
                                <td>{{ props.item.id }}</td>
                                <td class="text-xs-left">{{ props.item.customers_offer.offer_number }}</td>
                                <td class="text-xs-left">{{ getInternalNumber(props.item) }}</td>
                                <td class="text-xs-left">{{ props.item.product.reference }}</td>
                                <td class="text-xs-left">{{ props.item.product.manufacturer.name }}</td>
                                <td class="text-xs-left">{{ props.item.quantity }}</td>
                                <td class="text-xs-left">{{props.item.unit.code }}</td>
                                <td class="text-xs-right">{{props.item.unit_sales_price}}
                                    {{props.item.customers_offer.currency.name}}
                                </td>
                                <td class="text-xs-right">{{props.item.total_sales_price}}
                                    {{props.item.customers_offer.currency.name}}
                                </td>
                                <td class="text-xs-left">{{ props.item.customers_offers_positions_status.name }}</td>
                            </tr>
                        </template>
                    </v-data-table>

                </v-card>
            </v-flex>
        </v-layout>

        <v-layout row wrap justify-end mr-5>

            <v-flex xs12 sm12 md1 pr-4 pt-4 mr-5>

                <v-btn :loading="creatingOfferPositions" class="secondary white--text"
                       @click.native="createOrderPositions()">
                    Create Order Positions
                </v-btn>

            </v-flex>

        </v-layout>
    </div>
</template>

<script>
    import {
        Settings,
        PurchaseOrder
    } from '../../../store/namespace-helper'

    import _ from 'lodash'

    export default {
      name: 'unconfirmed-offer-positions',
      components: {},
      data () {
        return {
          isVisible: false,
          activeTab: 0,
          headers: [
                    {text: 'Position-ID', value: 'id'},
                    {text: 'Customer Offer Number', value: 'offer_number'},
                    {text: 'Internal Number', value: 'internal_number'},
                    {text: 'Reference', value: 'reference'},
                    {text: 'Manufacturer', value: 'manufacturers_id'},
                    {text: 'Quantity', value: 'quantity'},
                    {text: 'Unit', value: 'unit_id', sortable: false},
                    {text: 'Unit Price', value: 'unit_sales_price', align: 'right'},
                    {text: 'Total Price', value: 'total_sales_price', align: 'right'},
                    {text: 'Status', value: 'inquiries_position_status_id'}
          ],
          pagination: {},
          search: '',
          total: 0,
          rowsPageItems: [{'text': 'All', 'value': -1}],
          selectedOfferPositions: [],
          selectedOfferPositionsIDs: []
        }
      },
      mounted () {

      },
      methods: {
        visibilityChanged (isVisible, entry) {
          if (this.isVisible !== isVisible) {
            this.isVisible = isVisible
            if (isVisible) {
              console.log('tab visible, load data')
              this.loadItems()
            } else {

            }
          }
        },
        loadItems: function () {
          const {sortBy, descending, page, rowsPerPage} = this.pagination
          const query = {
            id: this.selectedItem.id,
            sortBy: sortBy || 'id',
            descending: descending ? 'desc' : 'asc',
            page: page || 1,
            limit: rowsPerPage !== -1 ? rowsPerPage : 0,
            search: this.search ? this.search : ''
          }
          if (this.selectedItem.id !== 0) {
            this.$store.dispatch(PurchaseOrder.actions.loadUnconfirmedOfferPositions, query)
          }
        },
        getInternalNumber (val) {
          if (val.inquiry_position) {
            return val.inquiry_position.internal_number
          } else {
            return val.internal_number
          }
        },
        createOrderPositions () {
          this.$store.dispatch(PurchaseOrder.actions.createOrderPositions, {
            selected_offer_positions: this.selectedOfferPositionsIDs,
            purchase_orders_id: this.selectedItem.id
          }).then(response => {
            this.activeTab = 3
          })
        },
        throttledLoadItems: _.debounce(function () {
          this.loadItems()
        }, 450),
        throttledTranslate: _.debounce(function (q, target) {
          this.translate(q, target)
        }, 450)

      },
      computed: {
        getItems () {
          this.total = this.$store.getters[PurchaseOrder.getters.unconfirmedOfferPositions].length
          return this.$store.getters[PurchaseOrder.getters.unconfirmedOfferPositions]
        },
        selectedItem () {
          return this.$store.getters[PurchaseOrder.getters.getSelectedPurchaseOrder]
        },
        loading () {
          return this.$store.getters[Settings.getters.loading]
        },
        creatingOfferPositions () {
          return this.$store.getters[PurchaseOrder.getters.creatingPurchaseOrderPositions]
        }
      },
      watch: {
        pagination: {
          handler () {
            this.loadItems()
          },
          deep: true
        },
        selectedOfferPositions: {
          handler (val) {
            this.selectedOfferPositionsIDs = val.map(a => a.id)
          },
          deep: true
        },
        search: {
          handler (val) {
            this.throttledLoadItems()
          },
          deep: true
        }
      }

    }
</script>

<style scoped>

    th:focus {
        outline: none !important;
    }

</style>



// WEBPACK FOOTER //
// src/components/PurchaseOrders/UnconfirmedOfferPositions/UnconfirmedOfferPositions.vue